<template>
  <div class="service-phone-list-v2-editor">
    <el-table :data="items" border size="small" empty-text="暂无客服，请点击下方按钮添加">
      <el-table-column label="机主姓名" min-width="110">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.owner_name"
            placeholder="后台管理用"
            @input="syncValue"
          />
        </template>
      </el-table-column>
      <el-table-column label="客服名称" min-width="130">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.name"
            placeholder="小程序展示名称"
            @input="syncValue"
          />
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="130">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.phone"
            placeholder="请输入电话号码"
            @input="syncValue"
          />
        </template>
      </el-table-column>
      <el-table-column label="接听时间段" min-width="260">
        <template slot-scope="scope">
          <div class="time-range-wrap">
            <el-time-select
              v-model="scope.row.service_time_start"
              placeholder="开始"
              value-format="HH:mm"
              :picker-options="timeSelectOptions"
              size="small"
              class="time-range-input"
              @change="onTimePartChange(scope.$index)"
            />
            <span class="time-range-separator">至</span>
            <el-time-select
              v-model="scope.row.service_time_end"
              placeholder="结束"
              value-format="HH:mm"
              :picker-options="timeSelectOptions"
              size="small"
              class="time-range-input"
              @change="onTimePartChange(scope.$index)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" :disabled="scope.$index === 0" @click="moveItem(scope.$index, 'up')">上移</el-button>
          <el-button
            type="text"
            :disabled="scope.$index === items.length - 1"
            @click="moveItem(scope.$index, 'down')"
          >下移</el-button>
          <el-button type="text" class="danger-text" @click="removeItem(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="editor-actions">
      <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addItem">添加客服</el-button>
    </div>

    <div class="form-tips">
      <i class="el-icon-warning-outline"/> 新版配置供发版后小程序使用；机主姓名仅后台可见，小程序展示客服名称、电话与接听时间段。
    </div>
  </div>
</template>

<script>
export default {
  name: "i-service-phone-list-v2",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      items: [],
      syncing: false,
      timeSelectOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.syncing) {
          return
        }
        this.items = this.parseValue(val)
      }
    }
  },
  methods: {
    parseValue(val) {
      if (!val || !String(val).trim()) {
        return []
      }
      try {
        const list = JSON.parse(val)
        if (!Array.isArray(list)) {
          return []
        }
        return list.map(item => {
          const range = this.parseTimeRange(item.service_time)
          return {
            owner_name: item.owner_name == null ? "" : String(item.owner_name),
            name: item.name == null ? "" : String(item.name),
            phone: item.phone == null ? "" : String(item.phone),
            service_time: item.service_time == null ? "" : String(item.service_time),
            service_time_start: range ? range[0] : "",
            service_time_end: range ? range[1] : ""
          }
        })
      } catch (e) {
        return []
      }
    },
    parseTimeRange(value) {
      if (!value || !String(value).trim()) {
        return null
      }
      const parts = String(value).split("-")
      if (parts.length < 2) {
        return null
      }
      const start = parts[0].trim()
      const end = parts.slice(1).join("-").trim()
      if (!start || !end) {
        return null
      }
      return [start, end]
    },
    onTimePartChange(index) {
      const item = this.items[index]
      const start = (item.service_time_start || "").trim()
      const end = (item.service_time_end || "").trim()
      item.service_time = start && end ? start + "-" + end : ""
      this.syncValue()
    },
    buildJson() {
      const list = []
      this.items.forEach(item => {
        const name = (item.name || "").trim()
        const phone = (item.phone || "").trim()
        const ownerName = (item.owner_name || "").trim()
        const serviceTime = (item.service_time || "").trim()
        if (!name && !phone && !ownerName && !serviceTime) {
          return
        }
        list.push({
          owner_name: ownerName,
          name: name,
          phone: phone,
          service_time: serviceTime
        })
      })
      return JSON.stringify(list)
    },
    syncValue() {
      this.syncing = true
      this.$emit("input", this.buildJson())
      this.$nextTick(() => {
        this.syncing = false
      })
    },
    addItem() {
      this.items.push({
        owner_name: "",
        name: "",
        phone: "",
        service_time: "",
        service_time_start: "",
        service_time_end: ""
      })
      this.syncValue()
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.syncValue()
    },
    moveItem(index, direction) {
      if (direction === "up" && index > 0) {
        const temp = this.items[index]
        this.$set(this.items, index, this.items[index - 1])
        this.$set(this.items, index - 1, temp)
      }
      if (direction === "down" && index < this.items.length - 1) {
        const temp = this.items[index]
        this.$set(this.items, index, this.items[index + 1])
        this.$set(this.items, index + 1, temp)
      }
      this.syncValue()
    },
    validate() {
      const names = []
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        const name = (item.name || "").trim()
        const phone = (item.phone || "").trim()
        const ownerName = (item.owner_name || "").trim()
        const serviceTime = (item.service_time || "").trim()
        if (!name && !phone && !ownerName && !serviceTime) {
          continue
        }
        if (!name) {
          return "请填写第 " + (i + 1) + " 条客服的客服名称"
        }
        if (!phone) {
          return "请填写「" + name + "」的联系电话"
        }
        if (names.indexOf(name) !== -1) {
          return "客服名称「" + name + "」重复，请修改"
        }
        names.push(name)
      }
      return ""
    }
  }
}
</script>

<style scoped lang="less">
.service-phone-list-v2-editor {
  width: 100%;
}

.editor-actions {
  margin-top: 12px;
}

.danger-text {
  color: #F56C6C;
}

.time-range-wrap {
  display: flex;
  align-items: center;
  width: 100%;
}

.time-range-separator {
  flex-shrink: 0;
  padding: 0 6px;
  color: #606266;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
}

.time-range-input {
  flex: 1;
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/i-service-phone-list-v2.vue